import { Dispatch, SetStateAction } from "react";
import firebase from "firebase/compat";

import { DocumentSnapshot, Query } from "../../../types/firebase.types";
import { GenericObject } from "../../../types/generic.types";
import { applyUpdateTimestamp } from "../../../utils/timestamp";
import { updateNotificationSeenBy } from "../reducer";

export const normalizeText = (text: string) => {
  return text.replace(/([A-Z])/g, " $1");
  // uppercase the first character
  // .replace(/^./, function(str){ return str.toUpperCase(); })
};

export const normalizeReduxNotification = (notifications: any[]) => {
  return notifications.reduce(
    (
      acc: {
        listIds: string[];
        listMap: GenericObject;
      },
      el: GenericObject
    ) => {
      return {
        listIds: [...acc.listIds, el.id],
        listMap: {
          ...acc.listMap,
          [el.id]: el,
        },
      };
    },
    {
      listIds: [],
      listMap: {},
    }
  );
};

export const updateNotificationInRedux = (
  notificationId: string,
  userId: string,
  dispatch: Dispatch<SetStateAction<any>>
) => {
  dispatch(
    updateNotificationSeenBy({
      userId,
      notificationId,
    })
  );
};

export const updateNotification = (
  notification: GenericObject,
  userId: string,
  dispatch: Dispatch<SetStateAction<any>>
) => {
  notification.ref
    .update(
      applyUpdateTimestamp({
        seenBy: firebase.firestore.FieldValue.arrayUnion(userId),
      })
    )
    .then(() => {
      updateNotificationInRedux(notification.id, userId, dispatch);
    })
    .catch((ex: any) => {
      console.log(ex.message);
    });
};

export const getNotificationsListQuery = (query: Query, indexSnapshot?: DocumentSnapshot) => {
  if (indexSnapshot) query = query.startAfter(indexSnapshot);

  return query;
};
